import { render, staticRenderFns } from "./itemdescription.vue?vue&type=template&id=47067db6&scoped=true"
import script from "./itemdescription.vue?vue&type=script&lang=js"
export * from "./itemdescription.vue?vue&type=script&lang=js"
import style0 from "./itemdescription.vue?vue&type=style&index=0&id=47067db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47067db6",
  null
  
)

export default component.exports